function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8094"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "lightbulb icon"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 7",
  d: "M14.391 26.534a.61.61 0 00.61.61h3.533a.61.61 0 100-1.22h-3.533a.61.61 0 00-.61.61z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 8",
  d: "M43.834 25.926h-3.533a.61.61 0 000 1.22h3.533a.61.61 0 000-1.22z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9",
  d: "M28.807 12.119v3.533a.61.61 0 001.22 0v-3.533a.61.61 0 00-1.22 0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 10",
  d: "M36.682 19.271a.611.611 0 00.863 0l2.5-2.5a.61.61 0 00-.863-.863l-2.5 2.5a.61.61 0 000 .863z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 11",
  d: "M21.291 33.8l-2.5 2.5a.61.61 0 00.863.863l2.5-2.5a.61.61 0 10-.863-.863z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12",
  d: "M19.656 15.91a.61.61 0 10-.863.863l2.5 2.5a.61.61 0 10.863-.863z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13",
  d: "M37.545 33.8a.61.61 0 00-.863.863l2.5 2.5a.61.61 0 10.863-.863z"
}))), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-lightbulb",
  d: "M26.017 40.3a1.4 1.4 0 00.234.771l.745 1.12a1.394 1.394 0 001.161.622h2.689a1.394 1.394 0 001.161-.622l.745-1.12a1.394 1.394 0 00.234-.771v-1.671h-6.971V40.3zm-4.186-12.13a7.627 7.627 0 001.9 5.046 12.523 12.523 0 012.274 3.984v.034h6.983V37.2a12.523 12.523 0 012.275-3.985 7.668 7.668 0 10-13.432-5.045zm7.67-3.486a3.49 3.49 0 00-3.486 3.486.7.7 0 01-1.395 0 4.886 4.886 0 014.881-4.881.7.7 0 010 1.395z",
  fill: "currentColor"
})));
var SvgLightbulb = function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 59"
  }, props), _ref);
};
export default SvgLightbulb;